<template>
  <div class="footer_wrap">
    <div class="footer">
      <div class="footer_topTab">
        <div class="footer_topTab_papa_logo"></div>
        <button class="footer_topTab_donateBtn" v-if="checkDonate()" @click="moveDonate()">후원하기
        </button>
      </div>
      <div class="footer_textBox">
        <div class="footer_textBox_title">사단법인 함께하는아버지들</div>
        <div class="footer_textBox_content">
          서울특별시 중구 퇴계로 18길10 호경빌딩 301호 대표 : 김혜준<br>
          사업자등록번호: 230-82-00174 전화: 02-415-7955 mail@fathers.or.kr <br>
          Copyright 2013. 사단법인 함께하는아버지들 All rights reserved
        </div>
      </div>
      <div class="footer_bottomTab">
        <a class="footer_bottomTab_tax" href="https://www.nts.go.kr/" target="_blank">국세청</a>
        <div class="footer_bottomTab_personal" @click="$router.push('/privacy')">개인정보 처리방침</div>
        <div class="footer_bottomTab_clause" @click="$router.push('/term')">서비스 이용약관</div>
      </div>
      <web-link-list-component></web-link-list-component>
    </div>
    <terms-modal></terms-modal>
  </div>
</template>

<script>
import WebLinkListComponent from "@/components/weblink/WebLinkListComponent";
import TermsModal from "@/components/modal/TermsModal";

export default {
  name: "PageFooter",
  mixins: [],
  components: {TermsModal, WebLinkListComponent},
  inject: [],
  provide() {
    return {}
  },
  props: {},
  data() {
    return {}
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
      moveDonate(){
          window.open('https://online.mrm.or.kr/RTsnoLd')
      },
    movePage(path) {
      if (this.$route.path === path) {
        return;
      }
      this.$router.push(path);
    },
    openModal(type) {
      this.$modal.show('terms-modal', {termsType: type, scroll: window.pageYOffset});
    },
    checkDonate() {
      if (this.$route.query.tab === 'donation') {
        return false;
      } else {
        return true;
      }
    }
  },
  watch: {},
}
</script>

<style scoped>

</style>